export const DEFAULT_COUNTRY = 'IN';
export const INTERNATIONAL_PREFIX = 'i';
export const fallbackConfig = {
  homePageDesktop: 'nf-desktop-homepage',
  homePageMobile: 'nf-mweb-homepage',
};
